import PreProposalActionTypes from "./preproposals.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE: any = {
  preproposalsListResponse: null,
  preproposalsListArr: [],
  pushToDialResponse: null,
  pushToDialLoading: false,
};

const preproposalsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case PreProposalActionTypes.PREPROPOSAL_LIST_ALL_SUCCESS:
      return {
        ...state,
        preproposalsListResponse: action.payload,
        preproposalsListArr: docodeHexResponse(
          action.payload,
          "GetAllPreLeadKey",
        ),
      };

    case PreProposalActionTypes.PREPROPOSAL_LIST_ALL_FAILURE:
      return {
        ...state,
        preproposalsListResponse: action.payload,
        preproposalsListArr: [],
      };

    case PreProposalActionTypes.PREPROPOSAL_LIST_ALL_CHANGED:
      return { ...state, preproposalsListResponse: null };

    /******************* End Preproposal List Details ******************************* */

    /*********************  Preproposal List Details Start ******************* */

    case PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_SUCCESS:
      return {
        ...state,
        preproposalsListResponse: action.payload,
        preproposalsListArr: docodeHexResponse(
          action.payload,
          "FetchPreproposalKey",
        ),
      };

    case PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_FAILURE:
      return {
        ...state,
        preproposalsListResponse: action.payload,
        preproposalsListArr: [],
      };

    case PreProposalActionTypes.PREPROPOSAL_LIST_SEARCH_CHANGED:
      return { ...state, preproposalsListResponse: null };

    /** ******************* END  Preproposal List Details ******************* */

    /** ******************* START PUSH TO DIALER ******************* */
    case PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_START:
      return { ...state, pushToDialLoading: true, pushToDialResponse: null };

    case PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_SUCCESS:
      return {
        ...state,
        pushToDialLoading: false,
        pushToDialResponse: action.payload,
      };

    case PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_FAILURE:
      return {
        ...state,
        pushToDialLoading: false,
        pushToDialResponse: action.payload,
      };

    case PreProposalActionTypes.PREPROPOSAL_PUSH_TO_DIAL_RESET:
      return { ...state, pushToDialResponse: null, pushToDialLoading: false };

    /** ******************* END PUSH TO DIALER ******************* */

    default:
      return state;
  }
};

export default preproposalsReducer;
